import { workspaceRequestSteps } from './constants';

const workspaceConditionMarkdown = ({ state, detail, condition }, prefix, intl) => (
  intl.formatMessage({ id: 'workspace.condition.state' }, {
    prefix,
    state: state === 'unknown' ? 'N/A' : state,
    detail,
    code: condition.code,
  })
);

const workspaceConditionsMarkdown = (conditions, intl) => {
  const prefix = conditions.length > 1 ? '- ' : '';
  const notCompatible = conditions.filter((r) => (r.state !== 'compatible'));

  if (notCompatible.length === 0) {
    return intl.formatMessage({ id: 'workspace.conditions.compatible' }, { prefix });
  }

  return notCompatible.map((c) => workspaceConditionMarkdown(c, prefix, intl)).join('\n');
};

export const workspaceRequestWizardErrorTitle = ({ steps }) => {
  const { activeStepIndex } = steps;
  const activeStep = Object.values(workspaceRequestSteps)[activeStepIndex].name;

  return `access.invalid.step.${activeStep}`;
};

export default workspaceConditionsMarkdown;
